import PolicyPage from "./PolicyPage";

export default function TermsConditions() {
  return (
    <PolicyPage
      slug="terms"
      title="Terms & Conditions"
      intro="These terms govern the use of the Fire Safety Systems website."
      sections={[
        {
          h: "Website content",
          p: [
            "The content of this website is provided for general information about Fire Safety Systems and the services we offer. Specific requirements for your premises should be discussed directly with our team.",
          ],
        },
        {
          h: "Enquiries and quotations",
          p: [
            "Submitting an enquiry through this website does not create a contractual relationship. Any work carried out by Fire Safety Systems is subject to a separate quotation and, where relevant, service agreement.",
          ],
        },
        {
          h: "Intellectual property",
          p: [
            "The Fire Safety Systems brand and website content are the property of Fire Safety Systems unless otherwise indicated.",
          ],
        },
      ]}
    />
  );
}
